export const ApprovalContactLabels = {
	AccountOwner: 'Account Owner',
	SecondaryAccountOwner: 'Secondary Account Owner',
	NetworkPolicyTeam: 'Network Policy Team',
	NetworkPolicySolutionArchitects: 'Network Policy Solution Architects',
	CyberSecurityTeam: 'Cyber Security Team',
	ProxyArchitects: 'Proxy Architects',
	OTCybersecurityRiskManagement: 'OT Cybersecurity Risk Management',
} as const;
